import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bank-section-redirect-component',
  templateUrl: './bank-section-redirect.component.html',
})
export class BankSectionRedirectComponent implements OnInit {

  @Input() private url: string;

  public redirectionUrl: string;

  constructor(
    private changeDetector: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.redirectionUrl = this.url;

    // window['mocks'] = window['mocks'] || {};
    // window['mocks']['bankSectionRedirectVisibility'] = (_isVisible: boolean = true) => {
    //   this.changeDetector.detectChanges();
    // };
  }

}
